<template>
	<div id="app" v-cloak>
		<img class="banner" src="../../../public/images/dwonload.png" alt="">
		<!-- <img class="banner" v-if="gsFlag == 0" src="../../../src/assets/logo/appBg.jpg" alt=""> -->
		<!-- <img class="banner" v-if="gsFlag == 1" src="../../../src/assets/logo/cljkLogo.png" alt=""> -->


		<!-- <div class="appTip" v-if="gsFlag != 1">
			<div>吉林省诚赉健康管理（集团）有限公司旗下</div>
			<div>以便民亲民，服务大众为主旨</div>
			<div>商城类App</div>
		</div> -->


		<img class="small" @click="show = true" src="../../../public/images/app-down.jpg" alt="">
		<div class="posf" v-if="show">
			<div class="close" @click="show = false"><i class="el-icon-circle-close"></i></div>
			<img src="../../../public/images/app_download.png" alt="">
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			show: false,
			gsFlag: localStorage.gsFlag
		}
	},
	created() {
		document.getElementById("app").scrollIntoView();
	}
}
</script>

<style scoped="scoped">
.close {
	position: absolute;
	right: 50px;
	top: 120px;
	color: #fff;
	font-size: 40px;
}

.posf {
	width: 100%;
	height: 100%;
	position: fixed;
	background: rgba(0, 0, 0, 0.5);
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
}

.banner {
	width: 100%;
	display: block;
}

.small {
	display: none;
}

[v-cloak] {
	display: none;
}

@media (max-width:500px) {
	.banner {
		display: none;
	}

	.small {
		display: block;
		width: 100%;
		display: block;
	}

	.close {
		position: absolute;
		right: 6vw;
		top: 8vh;
		color: #fff;
		font-size: 6vw;
	}
}

.appTip {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	position: absolute;
	top: 660px;
	right: 150px;
	color: #fff;
	font-size: 32px;
}

.appTip>div:not(:last-child) {
	margin-bottom: 10px;
}
</style>
